/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-18 11:41:56
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-04-25 15:17:18
 * @FilePath: /unifyxp-v2-store-portal/src/config/SiderConfig/SalesChannelProductSiderConfig.tsx
 */

import React, { useState } from 'react';
import { get } from 'lodash';
import { Icon } from '@/src/tools/icon';
import NameWithErr from 'src/constrains/SiderErrorController/SiderNameWithErr';
import { EnumSider, EnumSiderEvent } from 'src/types/common/sider';
import { updateSalesChannelProduct } from 'src/constrains/SiderErrorController/tools';
import { cancelAllRequests } from 'src/tools/server';
import { request_linkProductDetail } from '@/src/request/salesChannel/product';
import { uuid } from '@/src/tools/helper';
import { EnumSalesChannelMultiLanguage } from '@/src/types/server/params';
import { useAfterDidMountLanguageChanged } from 'src/constrains/SalesChannelMultiLanguageSelect/hooks';
import { salesChannelDict } from 'src/tools/urlMap';
import { getI18nFromGeneral } from 'src/tools/tools';

export const menuArray = ({ saleChannelUuid, salesChannelProductUuid }) => {
  const [showCustomisation, setShowCustomisation] = useState(true);
  const update = (forceUpdate) => {
    if (salesChannelProductUuid !== 'null') {
      request_linkProductDetail(saleChannelUuid, salesChannelProductUuid, {
        [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
        [EnumSalesChannelMultiLanguage.multiLanguageForceUpdate]: true,
        requestSourceID: uuid(),
      }).then((response: any) => {
        const salesChannelProduct = get(response, 'salesChannelProduct', {});
        const { products } = salesChannelProduct;
        const isVirtual = ['Service', 'GiftCard'].includes(
          get((products || [])[0], 'productType'),
        );
        if (isVirtual) {
          setShowCustomisation(false);
        } else {
          setShowCustomisation(true);
        }
      });
    }
    updateSalesChannelProduct({
      uuid: saleChannelUuid,
      productUuid: salesChannelProductUuid,
      forceUpdate,
    });
  };
  const _update = () => {
    update(true);
  };
  React.useEffect(() => {
    update(false);
    window.addEventListener(EnumSiderEvent.salesChannelProduct, _update);
    return () => {
      cancelAllRequests();
      window.removeEventListener(EnumSiderEvent.salesChannelProduct, _update);
    };
  }, []);
  useAfterDidMountLanguageChanged(_update); //想象能不能聚集到<SalesChannelWrapper/>里面去，这个wrapper 包裹salesChannel的Layout

  const _name = (name) => [salesChannelProductUuid, name];
  const arr = !showCustomisation
    ? [
        {
          path: `/salesChannel/products/link/${saleChannelUuid}/${salesChannelProductUuid}`,
          iconType: <Icon type='iconlink' style={iconStyle} />,
          name: (
            <NameWithErr
              name={getI18nFromGeneral('general.sider.linkProduct')}
              id={_name(EnumSider.SalesChannelProductLinkProduct)}
            />
          ),
          key: 'salesChannelProductsLink',
          routers: salesChannelDict.product, //['/salesChannel/products/link/*/*'],
        },
        {
          path: `/salesChannel/products/content/${saleChannelUuid}/${salesChannelProductUuid}`,
          iconType: <Icon type='iconcontent1' style={iconStyle} />,

          name: (
            <NameWithErr
              name={getI18nFromGeneral('general.sider.content')}
              id={_name(EnumSider.SalesChannelProductContent)}
            />
          ),
          key: 'salesChannelProductsContent',
          routers: salesChannelDict.productContent, //['/salesChannel/products/content/*/*'],
        },
        {
          path: `/salesChannel/products/alias/${saleChannelUuid}/${salesChannelProductUuid}`,
          iconType: <Icon type='iconproductsalias1' style={iconStyle} />,
          name: (
            <NameWithErr
              name={getI18nFromGeneral('general.sider.alias')}
              id={_name(EnumSider.SalesChannelProductAlias)}
            />
          ),
          key: 'salesChannelProductsAlias',
          routers: salesChannelDict.productAlias, //
          // [
          //   '/salesChannel/products/alias/*/*',
          //   '/salesChannel/products/alias/*/*/*',
          // ],
        },
      ]
    : [
        {
          path: `/salesChannel/products/link/${saleChannelUuid}/${salesChannelProductUuid}`,
          iconType: <Icon type='iconlink' style={iconStyle} />,
          name: (
            <NameWithErr
              name={getI18nFromGeneral('general.sider.linkProduct')}
              id={_name(EnumSider.SalesChannelProductLinkProduct)}
            />
          ),
          key: 'salesChannelProductsLink',
          routers: salesChannelDict.product, //['/salesChannel/products/link/*/*'],
        },
        {
          path: `/salesChannel/products/content/${saleChannelUuid}/${salesChannelProductUuid}`,
          iconType: <Icon type='iconcontent1' style={iconStyle} />,

          name: (
            <NameWithErr
              name={getI18nFromGeneral('general.sider.content')}
              id={_name(EnumSider.SalesChannelProductContent)}
            />
          ),
          key: 'salesChannelProductsContent',
          routers: salesChannelDict.productContent, //['/salesChannel/products/content/*/*'],
        },
        {
          path: `/salesChannel/products/alias/${saleChannelUuid}/${salesChannelProductUuid}`,
          iconType: <Icon type='iconproductsalias1' style={iconStyle} />,
          name: (
            <NameWithErr
              name={getI18nFromGeneral('general.sider.alias')}
              id={_name(EnumSider.SalesChannelProductAlias)}
            />
          ),
          key: 'salesChannelProductsAlias',
          routers: salesChannelDict.productAlias, //
          // [
          //   '/salesChannel/products/alias/*/*',
          //   '/salesChannel/products/alias/*/*/*',
          // ],
        },
        {
          path: `/salesChannel/products/customisation/${saleChannelUuid}/${salesChannelProductUuid}`,
          iconType: <Icon type='iconcustomization' style={iconStyle} />,
          name: getI18nFromGeneral('general.sider.customisation'),
          key: 'salesChannelProductsCustomisation',
          routers: salesChannelDict.productCustomization, //['/salesChannel/products/customisation/*/*'],
        },
      ];
  return arr;
};

const iconStyle = {
  //color: 'inherit',
  heihgt: '24px',
  width: '24px',
  fontSize: '24px',
};
